module.exports = __webpack_public_path__ + "img/food_steak.a7e86add.png";